import { Checkbox } from "@circleco/compass/components/Checkbox";
import { TextInput } from "@circleco/compass/components/TextInput";
import type { RefObject } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";

import { PollDuration } from "./PollDuration";
import { PollOptions } from "./PollOptions";

interface PollFieldsProps {
  canEditOptions: boolean;
  initialFocusRef?: RefObject<HTMLInputElement>;
}

export const PollFields = ({
  initialFocusRef,
  canEditOptions,
}: PollFieldsProps) => {
  const { control, watch } = useFormContext();
  const isPollDurationEnabled = watch("enable_poll_duration");

  return (
    <>
      <Controller
        control={control}
        name="title"
        render={({ field, fieldState }) => (
          <TextInput
            {...field}
            ref={initialFocusRef}
            error={fieldState.error?.message}
            label={t("tiptap.extensions.poll.ask_a_question")}
            placeholder={t("tiptap.extensions.poll.question_placeholder")}
          />
        )}
      />
      <PollOptions disabled={!canEditOptions} />
      <div className="border-primary flex flex-col gap-4 border-t pt-4">
        <Controller
          control={control}
          name="allow_members_to_view_results"
          render={({ field }) => (
            <Checkbox
              checked={Boolean(field.value)}
              label={t(
                "tiptap.extensions.poll.settings.allow_members_to_view_results",
              )}
              onCheckedChange={checked => field.onChange(checked)}
            />
          )}
        />
        <Controller
          control={control}
          name="enable_poll_duration"
          render={({ field }) => (
            <Checkbox
              checked={Boolean(field.value)}
              label={t("tiptap.extensions.poll.settings.poll_duration")}
              onCheckedChange={checked => field.onChange(checked)}
            />
          )}
        />
        {isPollDurationEnabled && <PollDuration />}
      </div>
    </>
  );
};
